import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import './resources/css/bootstrap.min.css';
import './resources/css/fa.css';
import './resources/css/ti.css';
import './resources/css/style.css';

ReactDOM.render(<App />, document.getElementById('root'));
